export default "__VITE_ASSET__DN0G15jj__"